<template>
  <el-form-item v-if="type === 'select'" :label="name || 'No label'">
    <el-select
      v-model="value.text"
      style="width:100%;"
    >
      <el-option
        v-for="item in value"
        :key="item.value"
        :value="item.text"
      />
    </el-select>
  </el-form-item>
  <el-form-item v-else :label="name || 'No label'">
    <el-input
      v-model="value"
      tabindex="1"
    />
  </el-form-item>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: '',

  props: {
    index: {
      type: Number,
      default: 0
    }
  },

  data () {
    return {
      popover: false
    }
  },
  created() {
    if (this.type === 'select') {

    }
  },
  computed: {
    ...mapState(['basic']),
    value: {
      get () {
        return this.basic.fields[this.index].value
      },
      set (v) {
        this.$store.dispatch('updateField', { index: this.index, data: { value: v } })
      }
    },
    text: {
      get () {
        return this.basic.fields[this.index].value.text
      },
      set (v) {
        this.$store.dispatch('updateField', { index: this.index, data: { value: v } })
      }
    },
    name: {
      get () {
        return this.basic.fields[this.index].name
      },
      set (v) {
        this.$store.dispatch('updateField', { index: this.index, data: { name: v } })
      }
    },
    type: {
      get () {
        return this.basic.fields[this.index].type
      },
      set (v) {
        this.$store.dispatch('updateField', { index: this.index, data: { type: v } })
      }
    }
  }
}
</script>

<style lang="scss">
@import '../assets/scss/variables';

.field-settings {
  position: absolute;
  right: -10px;
  top: 4px;
  color: $color-info;
  cursor: pointer;
  padding: 10px;
  &:hover {
    color: $color-primary;
  }
}
</style>
